<template>

  <div class="chart-section">
    <div class="chart-container">
     <apex-chart  type="donut" :options="chartOptions" :series="series" :key="series.length + 'P2P' + chartOptions.labels.length + change" ></apex-chart>

    </div>
    <div class="depsoits-label">دارایی شما</div>
    <div class="total-value-profit">
      <span class="total-change" :class="{positive:totalProfit>0,negative:totalProfit<0}" dir="ltr"><span v-if="totalProfit>0">+</span>{{totalProfit}}%</span>
      <div class="total-value">{{$toLocal(state.userInfo.totalTradesVolume,$decimal['TOMAN'])}}</div>
    </div>
    <div class="deposits">
        <div class="coin-row" v-for="(coin,index) in wallets" :key="index">
          <div class="symbol-amount">{{$toLocal(coin[1].credit, $decimal[coin[0]])}} &nbsp;{{$coinUnit[coin[0]]}}</div>
          <div class="row-left-section">
            <div class="symbol-title">{{$coinLabel[coin[0]]}} &nbsp;{{$coinUnit[coin[0]]}}</div>
<!--            <div class="colory-line" :style="{background: coin.color}"/>-->
            <div class="coin-percent">{{$toLocal(decimalFloorer((coin[1].credit/totalValue)*100),3)}}%</div>
          </div>
        </div>
    </div>
  </div>

</template>


<script>

export default {
  name: "DonutChartSection",
  props:[ 'basecoin'],


  data() {
    return {
      totalValue:0,
      change: 0,
      totalProfit:3,
      coins:[
        {name:'BITCOIN',value:3312,amount:0.04,color:'#E57373'},
        {name:'ETHEREUM',value:98,amount:0.0404,color:'#81C784'},
        {name:'BITCOIN_CASH',value:121,amount:0.04,color:'#4DD0E1'},
        {name:'STELLAR',value:365,amount:0.04,color:'#7986CB'},
        {name:'MATIC',value:2221,amount:0.04,color:'#BA68C8'},
        {name:'CELO',value:3312,amount:0.04,color:'#FF9ACC'},
        {name:'DOGE_COIN',value:3312,amount:0.04,color:'#4DB6AC'},
        {name:'TETHER',value:3628,amount:0.04,color:'#90A4AE'},
        {name:'LITE_COIN',value:6336,amount:0.04,color:'#FFB74D'},
        {name:'DOGE_COIN',value:2323,amount:0.04,color:'#F7EA72'},
        {name:'DOGE_COIN',value:4345,amount: 0.04,color:'#90A4AE'},
      ],
      wallets:[],
      chartOptions: {
        chart: {
          width: '100px',
          fontFamily: 'IBMPlexSans',
          fontSize: '16px',
          color: 'rgb(72, 77, 86)',

        },

        colors: [
          '#E57373', '#81C784', '#4DD0E1', '#7986CB', '#BA68C8', '#FF9ACC', '#FFB74D', '#F7EA72', '#4DB6AC', '#90A4AE'

        ],

        theme: {
          mode: 'light',
          palette: 'palette2'
        },

        stroke: {
          width: 1,
          colors: undefined,
          lineCap: 'round'
        },

        labels: [],

        dataLabels: {
          enabled: false,
          style: {
            fontFamily: 'IBMPlexSans'
          }
        },

        legend: {
          show: false,
          customLegendItems: [],
        },

        plotOptions: {
          pie: {
            borderRadius: 10,
            endingShape: 'rounded',

            offsetX: 0,
            offsetY: 0,
            donut: {
              borderRadius: 10,
              endingShape: 'rounded',

              size: '90%',
              background: '#091323',
              labels: {
                show: true,
                name: {
                  show: true,
                  fontSize: '16px',
                  fontFamily: 'IBMPlexSans',
                  fontWeight: 600,
                  color: 'rgba(215, 200, 200, 1)',
                  offsetY: -17,
                  formatter: function (val) {
                    return val.name || val
                  }
                },
                value: {
                  show: true,
                  fontSize: '14px',
                  fontFamily: 'Shabnam',
                  fontWeight: 400,
                  color: 'rgba(215, 200, 200, 1)',
                  offsetY: 10,
                  formatter: function (val) {
                    return parseFloat(val).toLocaleString()
                  }
                },
                total: {
                  show: true,
                  showAlways: false,
                  label: "ارزش کل دارایی ها",
                  fontSize: '24px',
                  fontFamily: 'Shabnam',
                  fontWeight: 600,
                  color: 'rgba(255, 255, 255, 1)',
                  formatter: function (w) {
                    w = w.globals.seriesTotals.reduce((a, b) => a + b)
                    return w.toLocaleString() + '\n' + 'تومان'
                  }
                }
              }
            },
          }
        },
        tooltip: {
          enabled: true,
          fillSeriesColor: true,
          custom: function ({
                              seriesIndex,
                              w
                            }) {
            return ` ${w.globals.seriesNames[seriesIndex].value.toLocaleString()} ${w.globals.seriesNames[seriesIndex].name} `
          }
        }
      },

      series: [0]
    }
  },
  methods:{
    totalValueCalculator(){
      this.coins.map(coin=>{
        this.totalValue+=coin.value
      })
    },
    decimalFloorer(value,decimal=2){
      const power =Math.pow(10,decimal)
      return Math.floor(value*power)/power
    },
    async getWalletData(){
      const res = await this.$axios(`/wallets/customer-addresses?walletType=EXCHANGE`)
      let entireRes = Object.entries(res)
      const sortCoins = this.$walletSortCoins
      entireRes.sort((a, b) => sortCoins.indexOf(a[0]) - sortCoins.indexOf(b[0]))
     entireRes = entireRes.filter(coin=> coin[1].credit !==0)
            this.contents = entireRes


      this.chartData = this.contents.map(e => e[0] === 'TOMAN' ? e[1].totalBalance : e[0].wholePriceOfCredit)
      this.wallets = entireRes
    },

    chart() {
      let index = 0
      this.wallets.forEach((e) => {
        this.chartOptions.labels[index] = {
          'name': this.$coins[e[0]].persianName,
          'value': e[1].credit || 0
        }
        this.series[index] = e[1].wholePriceOfCredit || e[1].totalBalance || 0
        index++
      })
      ++this.change
    },
  },
  computed: {
    credit() {
      return e => this.$toLocal(e[0] === 'TOMAN' ? e[1].credit.toFixed(0) : e[1].credit) || 0
    }
  },
  async mounted() {
    this.totalValueCalculator()
    await this.getWalletData()
    this.chart()
    // this.series=this.coins.map(coin => coin.value)
    // this.series=this.coins.map(coin => coin.value)
  },
}
</script>

<style scoped>
.total-value-profit{
  display: flex;
  margin-top: 25px;
  align-items: center;
  column-gap: 4px;
  justify-content: center;
}
.depsoits-label{
  font-size: clamp(14px,1.5vw,16px);
  color: #FFFFFF;
  margin-top: 8px;
  font-weight: bold;
}
.total-value{
  font-size: clamp(18px,2.1vw,24px);
  color: #FFFFFF;
}
  .chart-section{
    display: flex;
    flex-direction: column;
    padding: 30px 17px 20px 17px;
    background: linear-gradient(180deg, #091222 0%, #0A1425 100%);
    box-shadow: 0px 4px 24px -1px rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(40px);
    border-radius: 20px;
    flex-grow: 1;
    flex-basis: 250px;

    justify-content: center;
  }
  .deposits{
    display: flex;
    margin-top:55px ;
    flex-direction: column;
    row-gap: 28px;
    flex-grow: 1;
    }
  .positive{
    color: #04B3A2;
  }
  .negative{
    color: #D94F68;
  }

  .total-change{
    display: flex;
    align-items: center;
  }
   .chart-container{
     display: flex;
     justify-content: center;
     overflow: hidden;

   }
  .symbol-amount{
    color: #D7C8C8;
    font-size: clamp(11px,1.1vw,12px);
    display: flex;
    align-items: center;
    column-gap:5px;
  }

  .symbol-title{
    color: #D7C8C8;
    font-size: clamp(11px,1.1vw,12px);
    display: flex;
    align-items: center;
  }

  .coin-percent{
    color: #AEA3A3;
    font-size: 10px;
  }

  .colory-line{
    height: 13px;
    width: 2px;
    border-radius: 5px;
    background: blue;
  }

  .row-left-section{
    display: flex;
    align-items: center;
    justify-content: space-between;
    column-gap: 10px;
  }
.coin-row{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media(min-width: 1300px){
  .chart-section{
         min-width: 300px;
  }
}
@media(max-width: 400px){
  .chart-section{
    width: 80%;
  }
  .symbol-title{
    /*min-width: 300px;*/
    display: none;
  }
  .total-value-profit{
    flex-wrap: wrap;
    flex-direction: column;
  }

}
</style>